<main class="container is-max-widescreen mt-6">
  <div class="columns">
    <div class="column is-three-fifths">
      <h1 class="has-text-weight-semibold mb-6">Zamówienie z {{ cart.RestaurantName }}</h1>
      <h3 class="has-text-weight-medium">Sposób dostawy</h3>
      <form [formGroup]="deliveryFormGroup" id="deliveryForm">
        <fieldset>
          <div class="box mb-5" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="icon_div">
              <i class="fas fa-person-running"></i>
            </div>
            <div>
              <label for="online" class="has-text-weight-medium">Odbiór osobisty (0.00 zł)</label>
            </div>
            <div class="change_section">
              <input type="radio" id="delivery" name="delivery_type" formControlName="delivery_type" checked value="2" (change)="setDeliveryType($event)">
            </div>
          </div>

          <div class="box mb-5" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="icon_div">
              <i class="fas fa-car-side"></i>
            </div>
            <div>
              <label for="online" class="has-text-weight-medium">Dostawa do domu</label>
            </div>
            <div class="change_section">
              <input type="radio" id="delivery" name="delivery_type" formControlName="delivery_type" value="1"  (change)="setDeliveryType($event)">
            </div>
          </div>
        </fieldset>
      </form>



      <ng-container *ngIf="isDelivery">
        <h3 class="has-text-weight-medium">Adres dostawy</h3>
        <div class="box mb-5 address_form" fxLayout="row" fxLayoutAlign="flex-start center">
          <div class="icon_div">
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <div class="address_section">
            <ng-container *ngIf="isDelivery && !isDeliveryAddressLoaded">
              <div class="loader"></div>
            </ng-container>

            <form [formGroup]="addressFormGroup" id="addressForm">
              <div class="field">
                <label class="label is-size-7">Kod pocztowy i miejscowość</label>
                <div class="control" fxLayout="row" fxLayoutAlign="flex-start center">


                  <div class="postcode mr-1 " style="position: relative;">
                    <input type="text" class="input" placeholder="00-001"  formControlName="postcode" name="postcode" (focus)="isPostcodeOpen = true" (blur)="isPostcodeOpen = false" (change)="onPostcodeChange()">
                    <ul class="styled-dropdown postcode" *ngIf="isPostcodeOpen && filteredPostcodeOptions.length > 0">
                      <li
                        *ngFor="let item of filteredPostcodeOptions"
                        (mousedown)="selectPostcode(item)"
                        class="dropdown-item"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>


                  <div class="address_input" style="position: relative;">
                    <input type="text" class="input " placeholder="Miejscowość" formControlName="city" name="city" (focus)="isCityOpen = true" (blur)="isCityOpen = false" (change)="onCityChange()">
                    <ul class="styled-dropdown address_input" *ngIf="isCityOpen && filteredCityOptions.length > 0">
                      <li
                        *ngFor="let item of filteredCityOptions"
                        (mousedown)="selectCity(item)"
                        class="dropdown-item"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>


                </div>


                <p *ngIf="postcode?.hasError('invalid') && postcode?.touched" class="help is-danger">Podaj prawidłowy kod pocztowy</p>
                <p *ngIf="postcode?.hasError('not-supported') && postcode?.touched" class="help is-danger">Kod pocztowy nie jest obsługiwany</p>

                <p *ngIf="city?.hasError('invalid') && city?.touched" class="help is-danger">Podaj miejscowość</p>
                <p *ngIf="city?.hasError('not-supported') && city?.touched" class="help is-danger">Miejscowość nie jest obsługiwana</p>
              </div>

              <div class="field">
                <label class="label is-size-7">Adres</label>
                <div class="control" fxLayout="row" fxLayoutAlign="flex-start center">

                  <div class="address_input mr-1" style="position: relative;">
                    <input type="text" class="input " placeholder="Ulica" formControlName="address1" name="address1" (focus)="isAddress1Open = true" (blur)="isAddress1Open = false" (change)="onAddress1Change()">
                    <ul class="styled-dropdown address_input" *ngIf="isAddress1Open && filteredAddress1Options.length > 0">
                      <li
                        *ngFor="let item of filteredAddress1Options"
                        (mousedown)="selectAddress1(item)"
                        class="dropdown-item"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>


                  <input type="text" class="input number_input" formControlName="address2" name="address2">
                  <p class="slash_p mb-0">/</p>
                  <input type="text" class="input number_input--wider" formControlName="address3" name="address3">
                </div>
                <p *ngIf="address1?.hasError('invalid') && address1?.touched" class="help is-danger">Podaj adres</p>
                <p *ngIf="address1?.hasError('not-supported') && address1?.touched" class="help is-danger">Ulica nie jest obsługiwana</p>
                <p *ngIf="address2?.invalid && address2?.touched" class="help is-danger">Podaj numer budynku</p>
              </div>

              <div class="field">
                <label class="label is-size-7">Nr telefonu</label>
                <div class="control" fxLayout="row" fxLayoutAlign="flex-start center">
                  <input type="tel" name="phone" id="phone" placeholder="Nr telefonu"
                         class="input phone_input" formControlName="phone">
                </div>
                <p *ngIf="phone?.invalid && phone?.touched" class="help is-danger">Podaj prawidłowy numer telefonu</p>
              </div>
            </form>
            <div class="mt-2">


              <!-- [class.is-light]="!postcode?.valid || !city?.valid || !address1?.valid || !address2?.valid || !phone?.valid"
                [class.is-primary]="postcode?.valid && city?.valid && address1?.valid && address2?.valid && phone?.valid"
                [disabled]="!postcode?.valid || !city?.valid || !address1?.valid || !address2?.valid || !phone?.valid" -->


              <button class="btn button mr-1"
                [class.is-light]="!addressFormGroup.valid"
                [class.is-primary]="addressFormGroup.valid"
                [disabled]="!addressFormGroup.valid || deliveryRateCalculated"
                 (click)="saveAddressForm()">Zapisz i oblicz koszt dostawy</button>
              <!-- <button class="btn button is-danger" (click)="cancelForm()">Anuluj</button> -->
            </div>
          </div>
          <div class="change_section">


            <!-- <button *ngIf="addressFormGroup.invalid" class="btn has-text-grey" disabled>Zapisz</button> -->
          </div>
        </div>
      </ng-container>

      <h3 class="has-text-weight-medium">Kupon</h3>
      <div class="box mb-5 address_form" fxLayout="row" fxLayoutAlign="flex-start center">
        <div class="coupon_section">
          <form [formGroup]="couponFormGroup" id="couponForm">
            <div class="field">
              <div class="control" fxLayout="row" fxLayoutAlign="flex-start center">
                <input type="text" class="input" formControlName="coupon_name" name="coupon_name">
              </div>
            </div>

          </form>
          <div class="mt-2">
            <button [disabled]="!isCouponLoaded || couponFormGroup.get('coupon_name')?.value.length == 0"
            class="btn button mr-1 is-primary" (click)="saveCouponForm()"
            [class.spinner]="!isCouponLoaded"
            >Dodaj</button>
          </div>


        </div>
      </div>





      <!-- <h3 class="has-text-weight-medium">Kupon</h3>
      <div class="box mb-5" fxLayout="row" fxLayoutAlign="flex-start center">
        <form [formGroup]="couponFormGroup" id="couponForm">
          <div class="field">
            <input type="text" class="input" formControlName="coupon_name" name="coupon_name">
          </div>






        </form>
        <div class="mt-2">
          <button class="btn button mr-1 is-primary">Dodaj</button>
        </div>
      </div> -->



      <h3 class="has-text-weight-medium">Metoda płatności</h3>
      <form [formGroup]="paymentFormGroup" id="paymentForm">
        <fieldset >
          <!-- <div class="box" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="icon_div">
              <i class="fas fa-credit-card"></i>
            </div>
            <div>
              <label for="online_stripe" class="has-text-weight-medium">Płatność online - Stripe ({{ order!!.PaymentFee | number: '1.2-2' }} zł)</label>
            </div>
            <div class="change_section">
              <input type="radio" id="online_stripe_global" name="payment_type" formControlName="payment_type" value="1" checked (change)="setPaymentType($event)">
            </div>
          </div> -->

          <div class="box" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="icon_div">
              <i class="fas fa-wallet"></i>
            </div>
            <div>
              <label for="cash" class="has-text-weight-medium">Płatność gotówką</label>
            </div>
            <div class="change_section">
              <input type="radio" id="cash" name="payment_type" formControlName="payment_type" value="2" checked (change)="setPaymentType($event)">
            </div>
          </div>

          <div class="box" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="icon_div">
              <i class="fas fa-credit-card"></i>
            </div>
            <div>
              <label for="online_hotpay_global" class="has-text-weight-medium">Płatność online - HotPay</label>
            </div>
            <div class="change_section">
              <input type="radio" id="online_hotpay_global" name="payment_type" formControlName="payment_type" value="3"  (change)="setPaymentType($event)">
            </div>
          </div>
        </fieldset>
      </form>

    </div>
    <div class="column">
      <div class="box">
        <h2>Koszyk</h2>
        <div class="basket_row" fxLayout="row" fxLayoutAlign="flex-start center" *ngFor="let cartItem of $cartItems | async; let i=index">
          <div class="icon_div has-text-grey">
            {{ cartItem.Quantity }}x
          </div>
          <div>
            <p class="has-text-weight-medium mb-0">{{ cartItem.Name }}</p>
            <div class="is-size-7">
              <p class="m-0 has-text-grey" *ngFor="let ingredient of cartItem.AllIngredientNames">{{ ingredient }}</p>
            </div>

          </div>
          <div class="change_section">
            {{ (cartItem.TotalPriceV2 / 100) | number: '1.2-2' }} zł
          </div>
        </div>
        <hr>
        <section class="has-text-grey price_section">
          <div>Opłata za dowóz: <span class="has-text-weight-medium" *ngIf="deliveryRateCalculated || order!!.DeliveryType == 2">{{ (order!!.DeliveryFeeV2 / 100) | number: '1.2-2' }}zł</span>
                                <span class="has-text-weight-medium" *ngIf="!deliveryRateCalculated && order!!.DeliveryType == 1">Koszt zostanie obliczony po wprowadzeniu adresu</span>
          </div>
        </section>

        <!-- <hr>
        <section class="has-text-grey price_section">
          <div>Opłata za usługę płatności: <span class="has-text-weight-medium">{{ order!!.PaymentFee | number: '1.2-2' }}
            zł</span></div>
        </section> -->


        <ng-container *ngIf="order.Coupon != null">
          <hr>
          <section class="has-text-grey price_section" >
            <div>Zniżka {{ order!!.Coupon.name }}: <span class="has-text-weight-medium">-{{ (order!!.Coupon.value / 100) | number: '1.2-2' }}zł <span (click)="deleteCoupon()"><i style="color: Tomato; cursor: pointer;" class="fas fa-trash" ></i></span></span>
              <!-- TODO: implement different type of discount display -->
            </div>
          </section>
        </ng-container>



        <hr>
        <section class="total_section">
          <strong>Razem</strong>
          <span class="has-text-weight-medium" *ngIf="(!isDelivery || deliveryRateCalculated)">
            {{ (order!!.TotalV2 / 100) | number: '1.2-2' }} zł
          </span>
          <span *ngIf="isDelivery && (addressFormGroup.invalid || !deliveryRateCalculated)">
            -- zł
          </span>
        </section>

      </div>
      <button class="button is-success submit" [class.spinner]="loading" [disabled]="loading || (isDelivery && addressFormGroup.invalid) || (isDelivery && !deliveryRateCalculated)" (click)="createOrder()">Zamawiam i płacę</button>
    </div>
  </div>

</main>
